//----- Component --------------------------------------------------------/
// Developer :  Ignacio Bastianelli
// Creation Date :07/02/2025
// Version : 1.0
// Description : CRUD tabla Puestos
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useMemo, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import Navbar from "../../Navbar";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import EditNoteIcon from "@mui/icons-material/EditNote";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Button,
  Container,
  Alert,
  Box,
  Typography,
  ListItemIcon,
  MenuItem,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { getData } from "../../../services/library";
import PuestosDelete from "./PuestosDelete";
import PuestosForm from "./PuestosForm";
import { logEventos } from "../../../services/services";

const Puestos = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [rowInfo, setRowInfo] = useState({});
  const [puestos, setPuestos] = useState([]);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [openFormModal, setOpenFormModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [idToDelete, setIdToDelete] = useState(-1);

  const traerPuestos = () => {
    getData("/SP_puestos", setPuestos);
  };

  useEffect(() => {
    traerPuestos();
  }, []);

  const handleOpenCloseFormModal = () => {
    setOpenFormModal(!openFormModal);
  };

  const handleOpenCloseDeleteModal = () => {
    setOpenDeleteModal(!openDeleteModal);
  };

  const mostrarAlertaTemporal = (mensaje, severidad) => {
    setMostrarAlerta(true);
    setMessage(mensaje);
    setSeverity(severidad);

    setTimeout(() => {
      setMostrarAlerta(false);
    }, 5000);
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const columns = useMemo(
    () => [
      { header: "ID", accessorKey: "id", size: 25 },
      { header: "Puesto", accessorKey: "puesto", size: 60 },
      { header: "User", accessorKey: "user", size: 40 },
      { header: "Descripcion", accessorKey: "descripcion", size: 140 },
    ],
    []
  );

  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

    useEffect(() => {
    logEventos(
      "acceso al menú xTablas Ref RRHH",
     "RRHH", 
     "Lista Puestos",
      localStorage.getItem("user"));
  }, []);

  return (
    <>
      {openFormModal && (
        <PuestosForm
          isEditMode={isEditMode}
          rowInfo={isEditMode ? rowInfo : {}}
          handleOpenCloseModalForm={handleOpenCloseFormModal}
          obtenerPuestos={traerPuestos}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
        />
      )}
      {openDeleteModal && (
        <PuestosDelete
          id={idToDelete}
          setOpen={setOpenDeleteModal}
          open={openDeleteModal}
          getPuestos={traerPuestos}
          mostrarAlerta={mostrarAlertaTemporal}
        />
      )}
      {mostrarAlerta && (
        <Alert
          severity={severity}
          sx={{
            zIndex: 1600,
            position: "fixed",
            top: "20px",
            right: "20px",
            width: "auto",
            borderRadius: "8px",
            backgroundColor:
              severity === "success"
                ? "#d8e6d3"
                : severity === "error"
                ? "#efc3c3"
                : severity === "warning"
                ? "#f0efb6"
                : "#e6e6e6",
          }}
        >
          {message}
        </Alert>
      )}
      <Navbar />
      <Container maxWidth="xl" mt={1}>
        {puestos ? (
          <Box mt={2} mb={4}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                autoResetPageIndex={false} //Para que no se resete la paginacion al actualizar o eliminar una fila
                enableToolbarInternalActions={true}
                enableGrouping
                layoutMode="grid"
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    color: "black",
                    borderColor: "black",
                    backgroundColor: "#fff",
                    wordWrap: "break-word", // Permite que el texto se divida cuando sea necesario
                    whiteSpace: "normal", // Permite que el texto ocupe varias líneas
                  },
                })}
                enableColumnActions={true}
                enableColumnFilters={false}
                enableHiding={false}
                enableDensityToggle={false}
                localization={MRT_Localization_ES}
                enableColumnDragging={false}
                initialState={initialState}
                // renderDetailPanel={renderDetailPanel}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                columns={columns}
                data={puestos}
                enableStickyFooter
                enableRowActions
                positionActionsColumn="last"
                renderToolbarInternalActions={({ table }) => <></>}
                renderTopToolbarCustomActions={() => (
                  <Box sx={{ display: "flex" }}>
                    <Box
                      sx={{
                        marginRight: 2,
                      }}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<AddBoxTwoToneIcon color="asd" />}
                        aria-haspopup="true"
                        onClick={() => {
                          setIsEditMode(false);
                          handleOpenCloseFormModal();
                        }}
                      >
                        Añadir puesto
                      </Button>
                    </Box>
                    <Typography
                      variant="poster"
                      style={{ fontSize: 26, textAlign: "center" }}
                    >
                      Puestos
                    </Typography>
                  </Box>
                )}
                renderRowActionMenuItems={({ closeMenu, row }) => (
                  <Box>
                    <MenuItem
                      onClick={() => {
                        setIsEditMode(true);
                        setRowInfo(row.original);
                        closeMenu();
                        handleOpenCloseFormModal();
                      }}
                    >
                      <ListItemIcon>
                        <EditNoteIcon sx={{ color: "skyblue" }} />
                      </ListItemIcon>
                      Editar
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleOpenCloseDeleteModal();
                        setIdToDelete(row.original.id);
                        closeMenu();
                      }}
                    >
                      <ListItemIcon>
                        <HighlightOffIcon color="error" />
                      </ListItemIcon>
                      Eliminar
                    </MenuItem>
                  </Box>
                )}
              />
            </ThemeProvider>
          </Box>
        ) : null}
      </Container>
    </>
  );
};

export default Puestos;
